export const SUBSCRIPTIONS_PRICES = {
  cct: {
    0: 795,
    1: 645,
    2: 475,
  },
  ckt: {
    0: 595,
    1: 445,
    2: 275,
  },
};



// WEBPACK FOOTER //
// ./src/modules/examPrepDashboard/constants/subscription.js